import {defineStore} from 'pinia';
import { ModulePostBatch } from '@/stores/moduleConst';
import postBatchAPI from '@/apis/lg/postBatchAPI';
import { BaseStore } from '../baseStore';

const action = {
  setMessage(message) {
    this.total = message.Total;
    this.countItems = message.CountItems;
    this.processId = message.ProcessID;
  },
  endMessage() {},
};
const postBatchStore = new BaseStore(postBatchAPI);
export const usePostedBatch = defineStore(ModulePostBatch, {
  state: () => ({
    total: 0,
    countItems: 0,
    processId: null,
    ...postBatchStore.state,
  }),
  // Sử dụng toán tử ... để lấy ra các hàm của action (nvthinh 10.05.2024)
  actions: {...action, ...postBatchStore.action},
  getters: {
    ...postBatchStore.getters,
  },
});
